import './validator.plugin.js';
import scrollto from '@utils/scrollto.js';
const addFormValidation = (form) => {
    if (!form)
        return;
    // eslint-disable-next-line no-undef
    const validator = new Validator(form);
    form.validator = validator;
    function scrollToFirstError(el) {
        const firstInvalidField = el.querySelector('.is-invalid');
        const isMobile = true;
        if (firstInvalidField && isMobile) {
            scrollto(firstInvalidField, { duration: 700, offset: 120 });
        }
    }
    form.addEventListener('submit', (event) => {
        validator.reinit();
        const valid = validator === null || validator === void 0 ? void 0 : validator.validate(undefined, false);
        if (valid) {
            form.classList.remove('invalid');
            form.classList.add('valid');
        }
        else {
            event.preventDefault();
            form.classList.remove('valid');
            form.classList.add('invalid');
            scrollToFirstError(form);
        }
    });
    form.querySelectorAll('input, textarea, select').forEach((control) => {
        // control.addEventListener("focus", function(event){
        //   validator.reset();
        // }, false);
        control.addEventListener('change', () => {
            if (control.getAttribute('type') === 'checkbox') {
                validator.reset();
            }
        });
    });
};
document.querySelectorAll('form[data-validate]').forEach((form) => {
    addFormValidation(form);
});
